import { ValidationControlContext } from "./ValidationControlContext";

export type ValidationControlProviderProps = {
  children: React.ReactNode;
  enabled: boolean;
};

export const ValidationControlProvider = ({
  children,
  enabled,
}: ValidationControlProviderProps) => {
  return (
    <ValidationControlContext value={{ enabled }}>
      {children}
    </ValidationControlContext>
  );
};
